module.exports = __webpack_public_path__ + "static/media/email-icon.251a12d1.svg";